export const getFormattedPartyTypeCatalogCode = (partyType) => {
  if (partyType === 'lawyer_defendant') {
    return 'dea';
  }

  return partyType;
};
